<template>
	<div class="order-running map-obstruction" ref="obstruction" :class="{'page-hidden': this.isHiddenPage}">
		<div class="card">
			<template v-if="!isHubOrder">
				<!-- 状态概览：派车中 -->
				<RunningDispatching
					v-show="dispatchingVisible"
					:orderInfo="orderInfo"
				/>
				<!-- 状态概览：已接单未上车 -->
				 <RunningWaiting
				 		v-show="notOnVisible"
						:orderInfo="orderInfo"
						:countdownTime="countdownTime"
				 />
				<!-- 状态概览：已上车进行中 -->
				 <RunningPendding
				 		v-show="runningVisible"
						:orderInfo="orderInfo"
				 />
			</template>
			<!-- 枢纽站模式订单概览 -->
			<HubOrderRunningSummary v-else :orderInfo="orderInfo" />
			<!-- 站点概览 -->
			<StopSummary
				:orderInfo="orderInfo"
				:userPosInfo="userPosInfo"
				:notOn="notOnVisible"
			/>
			<!-- 取消按钮 -->
			<div class="bottom">
				<VanButton
					v-show="$OrderService.isOrderDispatching() || $OrderService.isOrderDispatchedAndUserNotGetOn()"
					class="cancel"
					@click="onClickCancel"
				>
					取消行程
				</VanButton>
			</div>
		</div>
		<go-back-trigger/>

		<CancelConfirmPopup
			v-model="cancelConfirmVisible"
			:record="orderInfo"
			@rule="onRefundRule"
			@refund="onRefund"
		/>
    <RefundRuleModal v-model="showRefundRuleModal" @close="onCloseRefundRule" />

    <!-- 派车等待时间过长提示 -->
    <DispatchWaitPopup
      :show="showModal"
      :ticketInfoId="ticketInfoId"
      :onTime="onTime"
      :offTime="offTime"
      @close="showModal = false"
    />
		<!-- loading -->
    <state-loading v-if="isHiddenPage" />

		<!-- 取消次数限制 -->
		<CancelLimitModal
			v-model="cancelLimitVisible"
			:maxCancelNum="cancelLimitInfo.limit"
			:cancelNum="cancelLimitInfo.cancel"
			@confirm="onCancelLimitConfirm"
			@close="onCancelLimitClose"
		/>
	</div>
</template>

<script>
import StateLoading from '../../components/state-loading/index.vue'
import GoBackTrigger from "../../components/go-back-trigger/index";
import {mapGetters} from 'vuex';
import DispatchWaitPopup from './components/DispatchWaitPopup.vue'
import {formatSeconds} from '../../utils/index'
import HubOrderRunningSummary from './components/HubOrderRunningSummary.vue';
import CancelLimitModal from './components/CancelLimitModal.vue';
import RunningDispatching from './components/RunningDispatching.vue';
import RunningWaiting from './components/RunningWaiting.vue';
import RunningPendding from './components/RunningPendding.vue';
import StopSummary from './components/StopSummary.vue';
import CancelConfirmPopup from './components/CancelConfirmPopup.vue';
import RefundRuleModal from './components/RefundRuleModal.vue'
let toast;
let intervalId;
export default {
	name: 'OrderRunning',
	components: {
		GoBackTrigger,
		DispatchWaitPopup,
		HubOrderRunningSummary,
		StateLoading,
		CancelLimitModal,
		RunningDispatching,
		RunningWaiting,
		RunningPendding,
		StopSummary,
		CancelConfirmPopup,
		RefundRuleModal
	},
	data() {
		return {
			loading: false,
			cancelConfirmVisible: false,
      showModal: false,
      countdownTime: '',
			isHiddenPage: false,
			cancelLimitVisible: false,
			cancelLimitInfo: {
				limit: 0,
				cancel: 0
			},
			showRefundRuleModal: false
		};
	},
	computed: {
		...mapGetters({
			orderInfo: 'order/orderInfo',
			userPosInfo: 'dataUserPosInfo',
		}),
		isHubOrder() {
			const { isHubOrder } = this.orderInfo || {}
			return isHubOrder || false;
		},
		ticketInfoId() {
			return Number.parseInt(this.$route.query.ticketInfoId) || undefined;
		},
		statusChangeText() {
			let {statusChangeText} = this.orderInfo || {};
			return statusChangeText;
		},
		dispatchingVisible() {
			return this.$OrderService.isOrderDispatching();
		},
		notOnVisible() {
			return this.$OrderService.isOrderDispatchedAndUserNotGetOn();
		},
		runningVisible() {
			return this.$OrderService.isOrderRunningWithUser();
		},
    onTime() {
      const {onTime} = this.orderInfo || {}
      return onTime || ''
    },
    offTime() {
      const {offTime} = this.orderInfo || {}
      return offTime || ''
    },
		sureStatusChangeText() {
			let {sureStatusChangeText} = this.orderInfo || {};
			return sureStatusChangeText;
		},
    isArrive() {
      const {isArrive} = this.orderInfo || {}
      return isArrive
    },
    showWaitModal() {
      const {showWaitModal} = this.orderInfo || {}
      return showWaitModal
    },
    sureTime() {
      const {sureTime} = this.orderInfo || {}
      return sureTime
    },
	},
	activated() {
		this.isHiddenPage = true
		this.loading = false;
		this.cancelConfirmVisible = false;
		this.$nextTick(() => {
			this.$MapService.setMapFitViewModeC();
			this.$MapService.observeMapObstruction(this.$refs.obstruction);
			if (this.ticketInfoId) {
				this.$AppService.setTicketInfoId(this.ticketInfoId);
			}
			this.refresh();
			this.$OrderService.startLooping();
			this.$MapService.setMapModeRunning();
			this.$MapService.setStateMapVisible(true);
			this.$MapService.setStateOnStopDraggable(false);
			this.$MapService.setStateOffStopDraggable(false);
			this.$MapService.setMapRenderFlag();
			// this.$MapService.setFitView();
		});

    if(this.isArrive && !intervalId && this.sureTime) {
      this.countdown(this.sureTime)
    }
	},
	beforeRouteLeave(to, from, next) {
		this.$MapService.setMapModeNormal();
		this.$OrderService.stopLooping();
    this.clearCountdown()
		this.cancelConfirmVisible = false;
		this.cancelLimitVisible = false;
		this.showRefundRuleModal = false;
		next();
	},
	watch: {
		statusChangeText(text) {
			if (text) {
				this.$cheToast({
					type: 'slot',
					html: `<div class="ok-toast"><div class="ok-icon"></div><div class="ok-text">${text}</div></div>`
				});
			}
		},
		sureStatusChangeText(text) {
			if (text) {
				this.$cheToast({
					type: 'slot',
					html: `<div class="ok-toast"><div class="ok-icon"></div><div class="ok-text">${text}</div></div>`
				});
			}
		},
    showWaitModal(val) {
      if (!this.showModal) {
        this.showModal = val
      }
    },
    isArrive: {
      immediate: true,
      handler(val) {
        if (val) {
          this.countdown(this.sureTime)
        } else {
          this.clearCountdown()
        }
      }
    }
	},
	methods: {
		refresh() {
			this.$OrderService.getOrderInfo(this.ticketInfoId).then(() => {
				this.loading = false;
				setTimeout(() => {
					this.isHiddenPage = false
				}, 550)
			}).catch((res) => {
				this.$toast(res.msg);
				this.loading = false;
				setTimeout(() => {
					this.isHiddenPage = false
				}, 550)
			});
		},
		onClickCancel() {
			this.$OrderService.checkCancelOrder(this.ticketInfoId).then((res) => {
				const { limit, cancel } = res || {}
				console.error('checkCancelOrder res: ', cancel, limit)
				if (!cancel || cancel <= 0) {
					this.onCancelLimitClose();
					this.cancelConfirmVisible = true;
				} else {
					this.cancelLimitInfo.limit = limit || 0;
					this.cancelLimitInfo.cancel = cancel || 0;
					this.cancelLimitVisible = true;
				}
			}).catch((res) => {
				this.$toast(res.msg);
			});
		},
		onCancelLimitConfirm() {
			this.cancelConfirmVisible = true;
		},
		onCancelLimitClose() {
			this.cancelLimitVisible = false;
			this.cancelLimitInfo = {
				limit: 0,
				cancel: 0
			}
		},
		onRefundRule() {
			this.cancelConfirmVisible = false;
			this.showRefundRuleModal = true;
		},
		onCloseRefundRule() {
			this.cancelConfirmVisible = true;
		},
		onRefund(ticketInfoId) {
			toast = this.$createToast({
				type: 'loading',
				text: '正在退款...'
			});
			toast.show();
			this.$OrderService.cancelOrder(ticketInfoId).then(() => {
				toast.hide();
				this.cancelConfirmVisible = false;
				this.$OrderService.turnToOrderCancel({}, {ticketInfoId});
			}).catch((res) => {
				toast.hide();
				this.$cheToast({
					type: 'fail',
					text: res.msg || '退款失败',
					timeout: 3000
				});
			});
		},
    countdown(seconds) {
      this.clearCountdown()
      if (!seconds) return
      intervalId = setInterval(() => {
        seconds--;
        this.countdownTime = formatSeconds(seconds)
        if (seconds === 0) {
          this.clearCountdown()
        }
      }, 1000);
    },
    clearCountdown() {
      if (intervalId) {
        clearInterval(intervalId)
        intervalId = null
      }
    }
	}
};
</script>

<style scoped lang="scss">
	@import "../../assets/style/common.scss";
	.order-running {
		width: 100%;
		height: auto;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 10;
		font-size: 12px;
		.card {
			background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 50%, #FFFFFF 100%);
			padding-bottom: constant(safe-area-inset-bottom);
			padding-bottom: env(safe-area-inset-bottom);
		}
		.bottom {
			width: 100%;
			padding: 0 20px 20px 20px;
		}

		.cancel {
			width: 100%;
			background: #ECEFF3;
			border-radius: 25px;
			height: 48px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #000000;
			line-height: 20px;
		}
	}
	.page-hidden {
		position: fixed;
		background: #fff;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		.card {
			opacity: 0;
		}
	}
</style>
